import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NumberSeparatorPipe } from 'src/app/core/pipes/number.separator.pipe';
import { TranslationModule } from 'src/app/i18n';
import { ModalTitleComponent } from 'src/app/shared/global/modal-title/modal-title.component';
import { RemoveEmptyContactsPipe } from '../phonebook-selector/remove-empty-contacts.pipe';
import { PhonebookCustomDto } from '../shared/phonebook-custom.model';

@Component({
    selector: 'selected-phonebooks',
    imports: [
        CommonModule,
        TranslationModule,
        ModalTitleComponent,
        NumberSeparatorPipe,
        RemoveEmptyContactsPipe,
    ],
    templateUrl: './selected-phonebooks.component.html'
})
export class SelectedPhonebooksComponent {
  constructor(
    protected dialogRef: MatDialogRef<SelectedPhonebooksComponent>,
    @Inject(MAT_DIALOG_DATA) public recipients: PhonebookCustomDto[]
  ) {}

  onClose() {
    this.dialogRef.close();
  }
}
